/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 图形验证码 的 **请求配置**
 *
 * @分类 5001
 * @请求头 `POST /erp/Admin/getVerify`
 */
const postGetVerifyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Admin/getVerify",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetVerify",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 图形验证码 的 **请求函数**
 *
 * @分类 5001
 * @请求头 `POST /erp/Admin/getVerify`
 */
export const postGetVerify = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetVerifyRequestConfig, requestData), ...args);
};
postGetVerify.requestConfig = postGetVerifyRequestConfig;
/**
 * 接口 发送验证码 的 **请求配置**
 *
 * @分类 5001
 * @请求头 `POST /erp/Admin/sendSms`
 */
const postSendSmsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Admin/sendSms",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSendSms",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 发送验证码 的 **请求函数**
 *
 * @分类 5001
 * @请求头 `POST /erp/Admin/sendSms`
 */
export const postSendSms = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSendSmsRequestConfig, requestData), ...args);
};
postSendSms.requestConfig = postSendSmsRequestConfig;
/**
 * 接口 修改密码 的 **请求配置**
 *
 * @分类 5001
 * @请求头 `POST /erp/Admin/resetPwdByPhone`
 */
const postResetPwdByPhoneRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Admin/resetPwdByPhone",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postResetPwdByPhone",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 修改密码 的 **请求函数**
 *
 * @分类 5001
 * @请求头 `POST /erp/Admin/resetPwdByPhone`
 */
export const postResetPwdByPhone = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postResetPwdByPhoneRequestConfig, requestData),
    ...args
  );
};
postResetPwdByPhone.requestConfig = postResetPwdByPhoneRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 检验用户是否存在权限操作 的 **请求配置**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/Admin/checkRole`
 */
const postCheckRoleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Admin/checkRole",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCheckRole",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 检验用户是否存在权限操作 的 **请求函数**
 *
 * @分类 4.58.0
 * @请求头 `POST /erp/Admin/checkRole`
 */
export const postCheckRole = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postCheckRoleRequestConfig, requestData), ...args);
};
postCheckRole.requestConfig = postCheckRoleRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/admin.js